import React, { useState, useEffect } from "react";
import { ModalComp, Notifs, Tour } from "../../shared";
import { FiPlus, FiBell, FiHome, FiVideo } from "react-icons/fi";
import { useTranslation } from "react-i18next";
const Notification = ({ openDash, toggleOptions, showOptions }) => {
  const { t } = useTranslation();
  const [showDashboard, setShowDashboard] = useState(false);

  const openDashboard = () => {
    setShowDashboard(!showDashboard);
    openDash(!showDashboard);
  };

  const [openModal, setOpenModal] = useState(false);
  const toggle = () => setOpenModal(!openModal);

  const [openTourModal, setOpenTourModal] = useState(false);
  const toggleTour = () => setOpenTourModal(!openTourModal);

  return (
    <>
      <ModalComp modal={openModal} toggle={toggle} component={<Notifs />} />
      <ModalComp
        modal={openTourModal}
        toggle={toggleTour}
        component={<Tour />}
      />
      <div className="d-flex align-items-center justify-content-center text-right notif">
        <i
          onClick={toggleOptions}
          className={`notificationCircle text-center d-block  cursor mx-1 gap-2
                    d-flex align-items-center justify-content-center
                    ${showOptions ? "bg-priimary text-white" : ""}`}
        >
          <FiPlus className="notiffont" />
          {/* {!isPhone ? <span>افزودن</span> : <></>} */}
          <span>{t("افزودن")}</span>
        </i>
        <i
          onClick={openDashboard}
          className={`notificationCircle text-center d-block  cursor gap-2
                    d-flex align-items-center justify-content-center
                     mx-1 ${showDashboard ? "bg-priimary text-white" : ""}`}
        >
          <FiHome className="notiffont" />
          {/* {!isPhone ? <span>خانه ها</span> : <></>} */}
          <span>{t("خانه ها")}</span>
        </i>
        <i
          onClick={toggle}
          className="notificationCircle text-center d-block gap-2 
                    d-flex align-items-center justify-content-center
                     cursor mx-1 position-relative"
        >
          <FiBell className="notiffont" />
          {/* {!isPhone ? <span>اعلان ها</span> : <></>} */}
          <span> {t("اعلانها")}</span>
          <i className="notification d-block position-absolute rounded-circle "></i>
        </i>




        <a
            href="https://mmaviot.com/setup/"
            target="_blank"
            rel="noopener noreferrer"
            className="notificationCircle text-center d-block  cursor
            d-flex align-items-center justify-content-center mx-1 gap-2"
          >
            <FiVideo className="notiffont" />
            <span>{t("راهنما")}</span>
            
          </a>



        {/* <i
                    onClick={toggleTour}
                    className="notificationCircle text-center d-block rounded-circle cursor icon-down-open-big"></i> */}
      </div>
    </>
  );
};

export { Notification };
